import React, { Component } from "react";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { UserApi } from "services/user";
import ReactHtmlParser from "react-html-parser";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const defaultDownloadCloud = `${CDN_URL}common/download-cloud-icon-default-lg.svg`;
const hoverDownloadCloud = `${CDN_URL}common/download-cloud-icon-hover-lg.svg`;
const downArrowDefault = `${CDN_URL}common/down-nav-triangle-default-lg.svg`;
const upArrowDefault = `${CDN_URL}common/up-nav-triangle-default-lg.svg`;
const downArrowHover = `${CDN_URL}common/down-nav-triangle-hover-lg.svg`;
const upArrowHover = `${CDN_URL}common/up-nav-triangle-hover-lg.svg`;
const downArrowSelected = `${CDN_URL}common/down-nav-triangle-selected-lg.svg`;
const upArrowSelected = `${CDN_URL}common/up-nav-triangle-selected-lg.svg`;

const downloadCloudProfile = `${CDN_URL}common/download-cloud-icon-profile-lg.svg`;
const downloadCloudBilling = `${CDN_URL}common/download-cloud-icon-billing-lg.svg`;
const downloadCloudSupport = `${CDN_URL}common/download-cloud-icon-support-lg.svg`;
const downloadCloudStorage = `${CDN_URL}common/download-cloud-icon-storage-lg.svg`;
const downloadCloudColocation = `${CDN_URL}common/download-cloud-icon-colocation-lg.svg`;

export class Eula extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      scrollPositionArrows: 0,
      upArrow: upArrowDefault,
      downArrow: downArrowDefault,
      scrollActive: false,
      version: null,
    };
  }
  componentDidMount() {
    this.getCurrentEula();
    this.getArrows();
  }

  getCurrentEula = () => {
    const { version } = this.props;
    let url = CDN_URL.split("cdn");

    const versionToUse = version ? version : "1.0";
    url = url[0];
    url = `${url}cdn/eula/eula-${versionToUse}.html`;
    UserApi.getEula(url)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;
        if (validResponse) {
          this.setState({ eula: response.data });
        }
      })
      .catch(() => {});
  };
  changeToHoverIcon = () => {
    const currentElementsClassList =
      document.getElementById("download-wrapper").classList;
    if (!currentElementsClassList.contains("selected")) {
      document.getElementById("eula-download-button").src = hoverDownloadCloud;
    }
  };
  changeToDefaultIcon = () => {
    const currentElementsClassList =
      document.getElementById("download-wrapper").classList;
    if (!currentElementsClassList.contains("selected")) {
      document.getElementById("eula-download-button").src =
        defaultDownloadCloud;
    }
  };
  changeToSelectedIcon = () => {
    const { site } = this.props;
    let selectedIcon = "";

    switch (site.module) {
      case "BILLING":
        selectedIcon = downloadCloudBilling;
        break;
      case "STORAGE":
        selectedIcon = downloadCloudStorage;
        break;
      case "SUPPORT":
        selectedIcon = downloadCloudSupport;
        break;
      case "ACCOUNT":
        selectedIcon = downloadCloudProfile;
        break;
      case "COLOCATION":
        selectedIcon = downloadCloudColocation;
        break;
      case "COLO":
        selectedIcon = downloadCloudColocation;
        break;
      default:
        break;
    }

    document.getElementById("eula-download-button").src = selectedIcon;
    document.getElementById("download-wrapper").classList.add("selected");
  };
  downloadPdf = () => {
    this.changeToSelectedIcon();
  };
  getArrows = (state, direction) => {
    switch (state) {
      case "HOVER":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowHover });
        } else {
          this.setState({ downArrow: downArrowHover });
        }
        break;
      case "SELECTED":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowSelected });
        } else {
          this.setState({ downArrow: downArrowSelected });
        }

        break;
      default:
        this.setState({ upArrow: upArrowDefault, downArrow: downArrowDefault });
        break;
    }
  };

  onScroll = (scrollTop) => {
    this.updateScrollArrows(scrollTop);
    this.setState({ scrollTop });
  };
  updateScrollArrows = (scrollTopBar) => {
    this.setState({ scrollPositionArrows: scrollTopBar / 177 });
  };

  setActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: true });
    }
  };
  removeActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: false });
    }
  };

  render() {
    const { site, version } = this.props;
    const { scrollTop, scrollActive, eula } = this.state;
    const versionToUse = version ? version : "1.0";
    return (
      <ScrollView
        module={scrollActive ? site.module : ""}
        scrollTop={scrollTop}
        onScrollStop={this.onScroll}
        onHoverOver={this.setActiveScrollbar}
        onHoverOut={this.removeActiveScrollbar}
      >
        <div className="eula-content-container footer14">
          {eula && (
            <div className="eula-details body10">{ReactHtmlParser(eula)}</div>
          )}
          <div className="download-wrapper" id="download-wrapper">
            <a
              href={`/cdn/eula/eula-${versionToUse}.pdf`}
              download={`eula-${versionToUse}.pdf`}
              aria-label={`eula-${versionToUse}.pdf`}
            >
              <img
                id="eula-download-button"
                src={defaultDownloadCloud}
                onMouseOver={() => this.changeToHoverIcon()}
                onMouseOut={() => this.changeToDefaultIcon()}
                onClick={() => this.downloadPdf()}
              />
            </a>
          </div>
        </div>
      </ScrollView>
    );
  }
}
